import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Redirect, Link } from 'react-router-dom'
import { Alert } from 'react-bootstrap';
import { Button } from 'react-bootstrap'
import SessionManager from '../Utils/SessionManager';

import MyLoader from '../Spinner/MyLoader';
import axios from 'axios';
import ModalFeeConfirmation from '../dialog/ModalFeeConfirmation';
import COLORS from '../resources/colors/COLORS';
import MdlFeePayDetails from '../dialog/MdlFeePayDetails';
import myToast from '../Utils/MyToast';

const DueFeeCollection = (props) => {
    // Helper function for deep cloning (used frequently)
    const deepClone = useCallback((obj) => JSON.parse(JSON.stringify(obj)), []);

    const currentMonthKey = useMemo(() => {
        const d = new Date();
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    }, []);

    const isAdvanceMonth = useCallback((monthItem) => {
        return Boolean(monthItem?.month && monthItem.month > currentMonthKey);
    }, [currentMonthKey]);
    
    // Helper function to reset fee state
    const resetFeeState = useCallback((fee) => {
        fee.isChecked = 'false';
        fee.payable_amount = fee.outstanding;
    }, []);

    const [isOpeniclick, setIsOpeniclick] = useState(false);
    const [isNoRecord, setIsNoRecord] = useState(false);
    const [isNoDue, setIsNoDue] = useState(false);
    const [showFeeConfirmation, setShowFeeConfirmation] = useState(false);
    const [mStudentFeeDetails, setMStudentFeeDetails] = useState([]);
    const [mStudentDueFee, setMStudentDueFee] = useState([]);
    const [mStudentDetails, setMStudentDetails] = useState([]);
    const [mAllSessionPayDetails, setMAllSessionPayDetails] = useState([]);
    const [mSessionPayDetails, setMSessionPayDetails] = useState([]);
    const [mAllSiblingPayDetails, setMAllSiblingPayDetails] = useState([]);
    const [oldDueData, setOldDueData] = useState([]);
    const [netPayableDue, setNetPayableDue] = useState(0);
    const [otherAmount, setOtherAmount] = useState('');
    const [TRANSACTION_ID, setTRANSACTION_ID] = useState('');
    const [SESSION_NAME, setSESSION_NAME] = useState('');
    const [STUDENT_NAME, setSTUDENT_NAME] = useState('');
    const [Loading, setLoading] = useState(false);
    const [manuallyUncheckedFees, setManuallyUncheckedFees] = useState(new Set());

    useEffect(() => {
        if (props.FeeDetails !== null && props.mStudentDetails && props.mStudentDetails.length > 0) {
            const feeDetails = props.FeeDetails || [];
            setMStudentFeeDetails(feeDetails);
            setMStudentDueFee(feeDetails);
            setMStudentDetails(props.mStudentDetails || []);
            setIsNoRecord(!(feeDetails && feeDetails.length > 0) ? true : false);
            setIsNoDue(false);
            try {
                setSESSION_NAME(props.mStudentDetails[0].class[0].session_name);
            } catch (e) {
                setSESSION_NAME('');
            }
            try {
                setSTUDENT_NAME(props.mStudentDetails[0].stu_name);
            } catch (e) {
                setSTUDENT_NAME('');
            }
        }
    }, [props.FeeDetails, props.mStudentDetails]);

    const HandleCloseiclick = useCallback(() => {
        setIsOpeniclick((v) => !v);
    }, []);

    useEffect(() => {
        if (mStudentFeeDetails && mStudentFeeDetails.length > 0) {
            setIsNoRecord(false);
            getDueFee();
            getAllSessionPayList();
            getAllSiblingPayList();
            getOldDueData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mStudentFeeDetails]);

    const iclick = useCallback((item) => {
        setMSessionPayDetails(item.pay_details);
        HandleCloseiclick();
    }, []);

    const onSessionPayDetailClicked = useCallback((item) => {
        props.action_session_pay_dtls(item.session_id, item.session_name);
    }, [props]);

    const onSiblingViewClick = useCallback((item) => {
        setMSessionPayDetails(item.pay_details);
        HandleCloseiclick();
    }, []);

    const onSiblingPayDetailClicked = useCallback((item) => {
        // Navigate to sibling fee details - you can implement this based on your routing
        if (props.action_sibling_pay_dtls) {
            props.action_sibling_pay_dtls(item.sibling_enrollment, item.sibling_name);
        }
    }, [props]);

    const HandleShowModalFeeConfirmation = useCallback(() => {
        setShowFeeConfirmation((v) => !v);
    }, []);


    const HandleCloseModalFeeConfirmation = useCallback(() => {
        setShowFeeConfirmation(false);
    }, []);


    const getDueFee = useCallback(() => {
        let dueFee = deepClone(mStudentDueFee);
        for (let i = dueFee.length - 1; i >= 0; i--) {
            const TAG_DUE = 'Due';
            const TAG_NOT_PAID = 'Not Paid';
            let flagRemove = false;
            let mApplicableFee = dueFee[i].applicable_fee || [];
            for (let j = mApplicableFee.length - 1; j >= 0; j--) {
                if (!(mApplicableFee[j].payment_status === TAG_DUE) && !(mApplicableFee[j].payment_status === TAG_NOT_PAID)) {
                    mApplicableFee.splice(j, 1);
                    flagRemove = true;
                }
            }
            if (flagRemove) {
                if (mApplicableFee.length !== 0) {
                    dueFee[i]['applicable_fee'] = mApplicableFee;
                } else {
                    dueFee.splice(i, 1);
                }
            }
        }
        if (dueFee.length === 0) {
            setIsNoDue(true);
            props.action_set_current_due(netPayableDue);
        } else {
            setMStudentDueFee(dueFee);
            initDueData(dueFee);
        }
    }, [mStudentDueFee, netPayableDue, props]);

    const initDueData = useCallback((dueFee) => {
        let updated = deepClone(dueFee);
        let totalDue = 0;
        // Reset other amount when initializing
        setOtherAmount('');
        for (let i = updated.length - 1; i >= 0; i--) {
            updated[i]['isChecked'] = 'true';
            let mApplicableFee = updated[i].applicable_fee || [];
            for (let j = mApplicableFee.length - 1; j >= 0; j--) {
                mApplicableFee[j]['isChecked'] = 'true';
                mApplicableFee[j]['payable_amount'] = mApplicableFee[j].outstanding;
                totalDue = Number(totalDue) + Number(mApplicableFee[j].outstanding);
            }
            updated[i]['applicable_fee'] = mApplicableFee;
        }
        setMStudentDueFee(updated);
        setNetPayableDue(totalDue);
        props.action_set_current_due(totalDue);
    }, [props]);

    const selectCollectionMonth = useCallback((pIndex) => {
        const updated = deepClone(mStudentDueFee);
        if (updated[pIndex].isChecked === 'true') {
            updated[pIndex]['isChecked'] = 'false';
            const mApplicableFee = updated[pIndex].applicable_fee || [];
            for (let j = mApplicableFee.length - 1; j >= 0; j--) {
                mApplicableFee[j]['isChecked'] = 'false';
                // Reset payable_amount to outstanding when unchecking
                mApplicableFee[j]['payable_amount'] = mApplicableFee[j].outstanding;
            }
            updated[pIndex]['applicable_fee'] = mApplicableFee;
            // Clear other amount if all items are unchecked
            const allUnchecked = updated.every((item, idx) => {
                if (idx === pIndex) return true;
                if (item.isChecked === 'false') return true;
                const fees = item.applicable_fee || [];
                return fees.every(fee => fee.isChecked === 'false');
            });
            if (allUnchecked) {
                setOtherAmount('');
            }
        } else {
            updated[pIndex]['isChecked'] = 'true';
            const mApplicableFee = updated[pIndex].applicable_fee || [];
            for (let j = mApplicableFee.length - 1; j >= 0; j--) {
                mApplicableFee[j]['isChecked'] = 'true';
                // Reset payable_amount to outstanding when manually checking
                mApplicableFee[j]['payable_amount'] = mApplicableFee[j].outstanding;
            }
            updated[pIndex]['applicable_fee'] = mApplicableFee;
            // Clear other amount when manually selecting
            setOtherAmount('');
        }
        setMStudentDueFee(updated);
    }, [mStudentDueFee]);

    const isAnyFeeSelected = useCallback((mApplicableFee) => {
        return mApplicableFee.some(fee => fee.isChecked === 'true');
    }, []);

    const getFeeKey = useCallback((monthIndex, feeIndex) => {
        return `${monthIndex}-${feeIndex}`;
    }, []);

    const getAvailableAmount = useCallback((feeData, excludeFee = null) => {
        // Calculate total available amount (excluding manually unchecked fees and excluded fee)
        let totalAvailable = 0;
        feeData.forEach((month, monthIdx) => {
            const mApplicableFee = month.applicable_fee || [];
            mApplicableFee.forEach((fee, feeIdx) => {
                // Skip the fee being excluded
                if (excludeFee && excludeFee.monthIndex === monthIdx && excludeFee.feeIndex === feeIdx) {
                    return;
                }
                // Skip manually unchecked fees
                const feeKey = getFeeKey(monthIdx, feeIdx);
                if (manuallyUncheckedFees.has(feeKey)) {
                    return;
                }
                // Count all fees (checked or unchecked) except manually unchecked ones
                totalAvailable += Number(fee.outstanding) || 0;
            });
        });
        return totalAvailable;
    }, [manuallyUncheckedFees, getFeeKey]);

    const redistributeAmount = useCallback((amount, feeData, excludeFee = null) => {
        if (amount <= 0) {
            // Reset all checkboxes and payable_amounts if amount is 0 or invalid
            const updated = deepClone(feeData);
            updated.forEach((month) => {
                const mApplicableFee = month.applicable_fee || [];
                mApplicableFee.forEach((fee) => resetFeeState(fee));
                month.applicable_fee = mApplicableFee;
                month.isChecked = 'false';
            });
            return updated;
        }

        // Validate: Check if amount can be distributed across available fees
        const availableAmount = getAvailableAmount(feeData, excludeFee);
        if (amount > availableAmount) {
            myToast.notify_warning(`Amount ₹${amount.toLocaleString()} exceeds available total of ₹${availableAmount.toLocaleString()} (excluding manually unchecked fees).`);
            return deepClone(feeData);
        }

        // Distribute amount across fees in order (by month, then by fee)
        // Continue to unchecked fees and next months if amount exceeds checked fees
        // But never re-check fees that were manually unchecked
        let remainingAmount = amount;
        const updated = deepClone(feeData);

        updated.forEach((month, monthIdx) => {
            const mApplicableFee = month.applicable_fee || [];
            let monthHasChecked = false;

            mApplicableFee.forEach((fee, feeIdx) => {
                // Skip the fee being excluded (currently being unchecked)
                if (excludeFee && excludeFee.monthIndex === monthIdx && excludeFee.feeIndex === feeIdx) {
                    fee.isChecked = 'false';
                    fee.payable_amount = fee.outstanding;
                    return;
                }

                // Never re-check fees that were manually unchecked
                const feeKey = getFeeKey(monthIdx, feeIdx);
                if (manuallyUncheckedFees.has(feeKey)) {
                    fee.isChecked = 'false';
                    fee.payable_amount = fee.outstanding;
                    return;
                }

                const outstanding = Number(fee.outstanding) || 0;

                if (remainingAmount <= 0) {
                    // No more amount to distribute
                    if (fee.isChecked === 'true') {
                        // If it was checked, uncheck it and reset
                        fee.isChecked = 'false';
                        fee.payable_amount = outstanding;
                    } else {
                        // Keep it unchecked
                        fee.isChecked = 'false';
                        fee.payable_amount = outstanding;
                    }
                } else if (remainingAmount >= outstanding) {
                    // Full amount for this fee - check it
                    fee.isChecked = 'true';
                    fee.payable_amount = outstanding;
                    remainingAmount -= outstanding;
                    monthHasChecked = true;
                } else {
                    // Partial amount for this fee - check it
                    fee.isChecked = 'true';
                    fee.payable_amount = remainingAmount;
                    remainingAmount = 0;
                    monthHasChecked = true;
                }
            });

            month.applicable_fee = mApplicableFee;
            month.isChecked = monthHasChecked ? 'true' : 'false';
        });

        return updated;
    }, [manuallyUncheckedFees, getFeeKey, getAvailableAmount]);

    const moveFeeUp = useCallback((monthIndex, feeIndex) => {
        if (feeIndex === 0) return; // Already at top
        const updated = deepClone(mStudentDueFee);
        const month = updated[monthIndex];
        const fees = month.applicable_fee || [];
        // Swap with previous fee
        [fees[feeIndex - 1], fees[feeIndex]] = [fees[feeIndex], fees[feeIndex - 1]];
        month.applicable_fee = fees;
        
        // If otherAmount exists, redistribute with new order
        if (otherAmount && parseFloat(otherAmount) > 0) {
            const redistributed = redistributeAmount(parseFloat(otherAmount), updated);
            setMStudentDueFee(redistributed);
        } else {
            setMStudentDueFee(updated);
        }
    }, [mStudentDueFee, otherAmount, redistributeAmount]);

    const moveFeeDown = useCallback((monthIndex, feeIndex) => {
        const updated = deepClone(mStudentDueFee);
        const month = updated[monthIndex];
        const fees = month.applicable_fee || [];
        if (feeIndex === fees.length - 1) return; // Already at bottom
        // Swap with next fee
        [fees[feeIndex], fees[feeIndex + 1]] = [fees[feeIndex + 1], fees[feeIndex]];
        month.applicable_fee = fees;
        
        // If otherAmount exists, redistribute with new order
        if (otherAmount && parseFloat(otherAmount) > 0) {
            const redistributed = redistributeAmount(parseFloat(otherAmount), updated);
            setMStudentDueFee(redistributed);
        } else {
            setMStudentDueFee(updated);
        }
    }, [mStudentDueFee, otherAmount, redistributeAmount]);

    const selectFeeName = useCallback((pIndex, cIndex) => {
        const updated = deepClone(mStudentDueFee);
        const mApplicableFee = updated[pIndex].applicable_fee || [];
        const isDistributing = otherAmount && parseFloat(otherAmount) > 0;
        const feeKey = getFeeKey(pIndex, cIndex);
        
        if (mApplicableFee[cIndex].isChecked === 'true') {
            // Unchecking a fee
            // Mark this fee as manually unchecked
            setManuallyUncheckedFees(prev => new Set([...prev, feeKey]));
            
            // Reset the fee being unchecked
            mApplicableFee[cIndex]['isChecked'] = 'false';
            mApplicableFee[cIndex]['payable_amount'] = mApplicableFee[cIndex].outstanding;
            updated[pIndex]['applicable_fee'] = mApplicableFee;
            
            if (!isAnyFeeSelected(mApplicableFee)) {
                updated[pIndex]['isChecked'] = 'false';
            }
            
            // Check if all items are unchecked
            const allUnchecked = updated.every((item, idx) => {
                if (idx === pIndex) {
                    const fees = item.applicable_fee || [];
                    return fees.every(fee => fee.isChecked === 'false');
                }
                if (item.isChecked === 'false') return true;
                const fees = item.applicable_fee || [];
                return fees.every(fee => fee.isChecked === 'false');
            });
            
            if (allUnchecked) {
                // Clear other amount if all items are unchecked
                setOtherAmount('');
                setManuallyUncheckedFees(new Set()); // Clear tracking when all unchecked
                setMStudentDueFee(updated);
            } else if (isDistributing) {
                // During distribution: redistribute the otherAmount excluding the unchecked fee
                const totalAmount = parseFloat(otherAmount);
                const redistributed = redistributeAmount(totalAmount, updated, {
                    monthIndex: pIndex,
                    feeIndex: cIndex
                });
                setMStudentDueFee(redistributed);
        } else {
                // Not distributing, just uncheck
                setMStudentDueFee(updated);
            }
        } else {
            // Checking a fee
            // Remove from manually unchecked set if it was there
            setManuallyUncheckedFees(prev => {
                const newSet = new Set(prev);
                newSet.delete(feeKey);
                return newSet;
            });
            
            mApplicableFee[cIndex]['isChecked'] = 'true';
            // Reset payable_amount to outstanding when manually checking
            mApplicableFee[cIndex]['payable_amount'] = mApplicableFee[cIndex].outstanding;
            updated[pIndex]['isChecked'] = 'true';
        updated[pIndex]['applicable_fee'] = mApplicableFee;
            
            if (isDistributing) {
                // During distribution: redistribute the total amount including the newly checked fee
                const totalAmount = parseFloat(otherAmount);
                const redistributed = redistributeAmount(totalAmount, updated);
                setMStudentDueFee(redistributed);
            } else {
                // Not distributing, just check
        setMStudentDueFee(updated);
                // Clear other amount when manually selecting (not during distribution)
                setOtherAmount('');
            }
        }
    }, [mStudentDueFee, otherAmount, redistributeAmount, getFeeKey, manuallyUncheckedFees]);

    const getSubtotal = useCallback((pIndex) => {
        let amt = 0;
        const mApplicableFee = (mStudentDueFee[pIndex] && mStudentDueFee[pIndex].applicable_fee) || [];
        for (let i = 0; i < mApplicableFee.length; i++) {
            if (mApplicableFee[i].isChecked === 'true') {
                // Use payable_amount if it exists (from other amount distribution), otherwise use outstanding
                const payableAmt = mApplicableFee[i].payable_amount !== undefined 
                    ? Number(mApplicableFee[i].payable_amount) || 0
                    : Number(mApplicableFee[i].outstanding) || 0;
                amt = amt + payableAmt;
            }
        }
        return amt;
    }, [mStudentDueFee]);

    const netPayableAmount = useMemo(() => {
        return mStudentDueFee.reduce((sum, _, idx) => sum + getSubtotal(idx), 0);
    }, [mStudentDueFee, getSubtotal]);

    // Check if distribution is possible
    const isDistributionPossible = useMemo(() => {
        if (netPayableAmount <= 0) return false;
        
        // If otherAmount is set, validate it can be distributed
        if (otherAmount && parseFloat(otherAmount) > 0) {
            const amount = parseFloat(otherAmount);
            const availableAmount = getAvailableAmount(mStudentDueFee);
            return amount <= availableAmount && amount > 0;
        }
        
        // If no otherAmount, check if there are selected fees
        return mStudentDueFee.some(month => {
            const fees = month.applicable_fee || [];
            return fees.some(fee => fee.isChecked === 'true');
        });
    }, [netPayableAmount, otherAmount, mStudentDueFee, getAvailableAmount]);

    // Get distribution validation message
    const getDistributionValidationMessage = useMemo(() => {
        if (netPayableAmount <= 0) {
            return "No amount to collect. Please select fees.";
        }
        
        if (otherAmount && parseFloat(otherAmount) > 0) {
            const amount = parseFloat(otherAmount);
            const availableAmount = getAvailableAmount(mStudentDueFee);
            if (amount > availableAmount) {
                return `Amount ₹${amount.toLocaleString()} exceeds available total of ₹${availableAmount.toLocaleString()}. Please reduce the amount or uncheck fewer fees.`;
            }
            if (amount <= 0) {
                return "Please enter a valid amount greater than 0.";
            }
        } else {
            // Check if any fees are selected
            const hasSelectedFees = mStudentDueFee.some(month => {
                const fees = month.applicable_fee || [];
                return fees.some(fee => fee.isChecked === 'true');
            });
            if (!hasSelectedFees) {
                return "Please select at least one fee to collect.";
            }
        }
        
        return null; // No validation error
    }, [netPayableAmount, otherAmount, mStudentDueFee, getAvailableAmount]);

    // Calculate total due amount (sum of all outstanding fees, regardless of checked state)
    const totalDueAmount = useMemo(() => {
        let total = 0;
        mStudentDueFee.forEach((month) => {
            const mApplicableFee = month.applicable_fee || [];
            mApplicableFee.forEach((fee) => {
                total += Number(fee.outstanding) || 0;
            });
        });
        return total;
    }, [mStudentDueFee]);


    const handleOtherAmountChange = useCallback((value) => {
        const amount = parseFloat(value) || 0;
        setOtherAmount(value);

        if (amount <= 0) {
            // Reset all checkboxes and payable_amounts if amount is 0 or invalid
            const updated = redistributeAmount(0, mStudentDueFee);
            setMStudentDueFee(updated);
            setManuallyUncheckedFees(new Set());
            return;
        }

        // Validate amount doesn't exceed total due
        if (amount > totalDueAmount) {
            myToast.notify_warning(`Amount cannot exceed total due of ₹${totalDueAmount.toLocaleString()}`);
            setOtherAmount('');
            return;
        }

        // Validate amount can be distributed (excluding manually unchecked fees)
        const availableAmount = getAvailableAmount(mStudentDueFee);
        if (amount > availableAmount) {
            myToast.notify_warning(`Amount ₹${amount.toLocaleString()} exceeds available total of ₹${availableAmount.toLocaleString()} (excluding manually unchecked fees).`);
            setOtherAmount('');
            return;
        }

        // Distribute amount using the redistribute function
        // This will continue to unchecked fees and next months if needed
        // But will never re-check manually unchecked fees
        const updated = redistributeAmount(amount, mStudentDueFee);
        setMStudentDueFee(updated);
    }, [mStudentDueFee, totalDueAmount, redistributeAmount, getAvailableAmount]);

    const getAllSessionPayList = useCallback(() => {
        try {
            setMAllSessionPayDetails(mStudentDetails[0].all_session_pay_details || []);
        } catch (e) {
            setMAllSessionPayDetails([]);
        }
    }, [mStudentDetails]);

    const getAllSiblingPayList = useCallback(() => {
        try {
            // Use siblings_pay_details from API response
            const siblingsPayDetails = mStudentDetails[0].siblings_pay_details || [];
            const siblingPayDetails = siblingsPayDetails.map(sibling => {
                try {
                    return {
                        sibling_name: sibling.stu_name || sibling.student_enrollment_no,
                        sibling_enrollment: sibling.student_enrollment_no,
                        pay_details: sibling.pay_details || [{ total_due: 0 }]
                    };
                } catch (e) {
                    return {
                        sibling_name: sibling.stu_name || sibling.student_enrollment_no,
                        sibling_enrollment: sibling.student_enrollment_no,
                        pay_details: [{ total_due: 0 }]
                    };
                }
            });
            setMAllSiblingPayDetails(siblingPayDetails);
        } catch (e) {
            setMAllSiblingPayDetails([]);
        }
    }, [mStudentDetails]);

    const getOldDueData = useCallback(() => {
        try {
            const oldDue = mStudentDetails[0].old_due || [];
            setOldDueData(oldDue);
        } catch (e) {
            setOldDueData([]);
        }
    }, [mStudentDetails]);

    const oldDueTotals = useMemo(() => {
        if (!oldDueData || oldDueData.length === 0) {
            return { totalOldDue: 0, accessories_due: '' };
        }
        
        let totalOldDue = 0;
        
        oldDueData.forEach(item => {
            const amount = parseFloat(item.amount || 0);
            const amountPaid = parseFloat(item.amount_paid || 0);
            const settled_amount = parseFloat(item.settled_amount || 0);
            const remaining = amount - amountPaid-settled_amount;
            
            totalOldDue += remaining;
        });
        
        return { totalOldDue, accessories_due: '' };
    }, [oldDueData]);

    const submitFeeDetails = useCallback((transaction_date, payment_mode, payment_remark, request_id = '') => {
        setShowFeeConfirmation(false);
        setLoading(true);

        const SCHOOL_CODE = SessionManager.getSchoolCode();
        const STUDENT_ID = mStudentDetails[0].student_enrollment_no;
        const mStaffData = SessionManager.getStaffDetails();
        const STAFF_ID = mStaffData.staff_id;
        const CLASS_ID = mStudentDetails[0].class[0].class_id;
        const SECTION_ID = mStudentDetails[0].class[0].section_id;
        const SESSION_ID = mStudentDetails[0].class[0].session_id;

        const arrTemp = deepClone(mStudentDueFee);
        for (let index = 0; index < arrTemp.length; index++) {
            const element = arrTemp[index];
            arrTemp[index]['applicable_fee'] = JSON.stringify(element.applicable_fee);
        }
        const STR_FEE_DETAILS = JSON.stringify(arrTemp);
        const REMARK = payment_remark;
        const AMOUNT = netPayableAmount;
        const TRANSACTION_DATE = transaction_date;
        const PAYMENT_MODE = payment_mode;

        const FUNCTION_NAME = 'submitFeeDetails.php';
        const URL = process.env.REACT_APP_SERVER_NAME + process.env.REACT_APP_TARGET_DIR + FUNCTION_NAME;
        console.log("URL>>>>>" + URL);

        var params = new URLSearchParams();
        params.append('student_id', STUDENT_ID);
        params.append('class_id', CLASS_ID);
        params.append('section_id', SECTION_ID);
        params.append('session_id', SESSION_ID);
        params.append('staff_id', STAFF_ID);
        params.append('fee_details', STR_FEE_DETAILS);
        params.append('remark', REMARK);
        params.append('transaction_date', TRANSACTION_DATE);
        params.append('payment_mode', PAYMENT_MODE);
        params.append('amount', AMOUNT);
        params.append('current_due', netPayableDue);
        params.append('school_code', SCHOOL_CODE);
        params.append('request_id', request_id || `${Date.now()}-${STUDENT_ID}`);

        axios.post(URL, params).then(res => res.data)
            .then((response) => {
                let api_status = response.api_status;
                let transaction_id = response.data;
                if (api_status == 'OK') {
                    myToast.notify_success('Fee collected successfully');
                    props.action(true, transaction_id, AMOUNT);
                }
                else {
                    let api_remark = response.api_remark;
                    myToast.notify_warning(api_remark);
                    props.action(false, transaction_id, 0);
                }
            }).catch((error) => {
                setLoading(false);
                console.log('error>>>>>' + error);
            });
    }, [mStudentDetails, mStudentDueFee, netPayableAmount, netPayableDue, props]);


    if (Loading) {
        return <MyLoader />
    } else {
        if (isNoRecord) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '400px',
                    padding: '40px 20px'
                }}>
                    <div style={{
                        width: '120px',
                        height: '120px',
                        borderRadius: '50%',
                        background: `linear-gradient(135deg, ${COLORS.grey2}, ${COLORS.grey3})`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '24px',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.1)'
                    }}>
                        <i className="fa fa-file-text-o" aria-hidden="true" style={{ fontSize: '48px', color: COLORS.grey5 }}></i>
                    </div>
                    <h2 style={{
                        margin: 0,
                        fontSize: '24px',
                        fontWeight: '600',
                        color: COLORS.black8,
                        marginBottom: '8px'
                    }}>
                        No Fee Record Found
                    </h2>
                    <p style={{
                        margin: 0,
                        fontSize: '16px',
                        color: COLORS.black5,
                        textAlign: 'center'
                    }}>
                        There are no fee records available for this student.
                    </p>
                </div>
            )
        }
        else if (isNoDue) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '400px',
                    padding: '40px 20px'
                }}>
                    <div style={{
                        width: '120px',
                        height: '120px',
                        borderRadius: '50%',
                        background: `linear-gradient(135deg, ${COLORS.green_light}, ${COLORS.card_green})`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '24px',
                        boxShadow: '0 8px 24px rgba(137,190,76,0.2)'
                    }}>
                        <i className="fa fa-check-circle" aria-hidden="true" style={{ fontSize: '48px', color: COLORS.white }}></i>
                    </div>
                    <h2 style={{
                        margin: 0,
                        fontSize: '24px',
                        fontWeight: '600',
                        color: COLORS.black8,
                        marginBottom: '8px'
                    }}>
                        No Fee Due
                    </h2>
                    <p style={{
                        margin: 0,
                        fontSize: '16px',
                        color: COLORS.black5,
                        textAlign: 'center'
                    }}>
                        All fees have been paid. Great job!
                    </p>
                </div>
            )
        }
        else {
            return (
                <div style={{ padding: '0 20px' }}>
                    {/* All Sibling Due Section */}
                    {mAllSiblingPayDetails && mAllSiblingPayDetails.length > 0 && (
                        <div style={{ 
                            marginBottom: '12px',
                            background: COLORS.white,
                            borderRadius: '14px',
                            border: '1px solid #e5e7eb',
                            boxShadow: '0 4px 12px rgba(15,23,42,0.08)',
                            overflow: 'hidden'
                        }}>
                            {/* Header */}
                            <div style={{ 
                                padding: '10px 14px',
                                background: `linear-gradient(135deg, ${COLORS.primary_color_shade7}, ${COLORS.primary_color_shade5})`,
                                borderBottom: '1px solid rgba(255,255,255,0.1)'
                            }}>
                                <h3 style={{ 
                                    margin: 0, 
                                    color: COLORS.white, 
                                    fontSize: '17px', 
                                    fontWeight: '600',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    <i className="fa fa-users" aria-hidden="true"></i>
                                    All Sibling Due ({STUDENT_NAME})
                                </h3>
                            </div>

                            {/* Sibling Cards */}
                            <div style={{ 
                                padding: '10px',
                                display: 'grid', 
                                gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', 
                                gap: '6px' 
                            }}>
                                {mAllSiblingPayDetails.map((item, index) => {
                                    const payDetails = item.pay_details && item.pay_details[0] ? item.pay_details[0] : {};
                                    const totalDue = parseFloat(payDetails.total_due || 0);
                                    const currentDue = parseFloat(payDetails.current_due || 0);
                                    const hasDue = totalDue > 0;
                                    const currentStudentEnrollment = mStudentDetails[0]?.student_enrollment_no || '';
                                    const isCurrentStudent = item.sibling_enrollment === currentStudentEnrollment;
                                    return (
                                        <div
                                            key={index}
                                            onClick={() => onSiblingPayDetailClicked(item)}
                                            style={{
                                                background: hasDue ? COLORS.radish0 : COLORS.green_light,
                                                borderRadius: '10px',
                                                padding: '8px',
                                                boxShadow: isCurrentStudent 
                                                    ? `0 0 0 2px ${COLORS.primary_color_shade5}, 0 4px 12px rgba(0,0,0,0.15)` 
                                                    : '0 4px 12px rgba(0,0,0,0.1)',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease',
                                                position: 'relative',
                                                overflow: 'visible',
                                                border: isCurrentStudent 
                                                    ? `2px solid ${COLORS.primary_color_shade5}` 
                                                    : `2px solid ${hasDue ? COLORS.card_red : COLORS.card_green}`
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-4px)';
                                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                                            }}
                                        >
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'flex-start',
                                                marginBottom: '4px'
                                            }}>
                                                <div style={{ flex: 1 }}>
                                                    <div style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '4px',
                                                        background: hasDue ? COLORS.radish1 : COLORS.green_light,
                                                        color: hasDue ? COLORS.card_red : COLORS.green_dark,
                                                        padding: '3px 8px',
                                                        borderRadius: '6px',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        marginBottom: '3px'
                                                    }}>
                                                        <i className="fa fa-user" style={{ fontSize: '10px' }}></i>
                                                        {item.sibling_name}
                            </div>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: '2px'
                                                    }}>
                                                        <div style={{ 
                                                            color: hasDue ? COLORS.card_red : COLORS.green_dark, 
                                                            fontSize: '14px', 
                                                            fontWeight: '600'
                                                        }}>
                                                            Current: Rs. {currentDue}
                                        </div>
                                                        <div style={{ 
                                                            color: hasDue ? COLORS.card_red : COLORS.green_dark, 
                                                            fontSize: '14px', 
                                                            fontWeight: '600'
                                                        }}>
                                                            Total: Rs. {totalDue}
                                        </div>
                                            </div>
                                                    {isCurrentStudent ? (
                                                        <div style={{
                                                            marginTop: '4px',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: '3px',
                                                            background: COLORS.primary_color_shade5,
                                                            color: COLORS.white,
                                                            padding: '3px 6px',
                                                            borderRadius: '10px',
                                                            fontSize: '9px',
                                                            fontWeight: '700',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            boxShadow: '0 2px 8px rgba(3,169,244,0.3)'
                                                        }}>
                                                            <i className="fa fa-check-circle" style={{ fontSize: '8px' }}></i>
                                                            Current
                                            </div>
                                                    ) : (
                                                        <div style={{
                                                            fontSize: '10px',
                                                            color: '#6b7280',
                                                            marginTop: '2px',
                                                            fontFamily: 'monospace',
                                                            fontWeight: '400'
                                                        }}>
                                                            {item.sibling_enrollment}
                                        </div>
                                                    )}
                                    </div>
                                                <div
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onSiblingViewClick(item);
                                                    }}
                                                    style={{
                                                        width: '28px',
                                                        height: '28px',
                                                        borderRadius: '50%',
                                                        background: hasDue 
                                                            ? `rgba(239,83,80,0.15)` 
                                                            : `rgba(137,190,76,0.15)`,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        cursor: 'pointer',
                                                        color: hasDue ? COLORS.card_red : COLORS.green_dark,
                                                        fontWeight: 'bold',
                                                        fontSize: '11px',
                                                        transition: 'all 0.2s ease',
                                                        border: `1px solid ${hasDue ? COLORS.card_red : COLORS.green_dark}`
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.background = hasDue 
                                                            ? `rgba(239,83,80,0.25)` 
                                                            : `rgba(137,190,76,0.25)`;
                                                        e.currentTarget.style.transform = 'scale(1.1)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.background = hasDue 
                                                            ? `rgba(239,83,80,0.15)` 
                                                            : `rgba(137,190,76,0.15)`;
                                                        e.currentTarget.style.transform = 'scale(1)';
                                                    }}
                                                >
                                                    <i className="fa fa-eye" aria-hidden="true"></i>
                                </div>
                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* Old Due Section */}
                    {oldDueData && oldDueData.length > 0 && (
                        <div style={{ 
                            marginBottom: '12px',
                            background: COLORS.white,
                            borderRadius: '12px',
                            border: '1px solid #e5e7eb',
                            boxShadow: '0 2px 8px rgba(15,23,42,0.06)',
                            padding: '10px 12px'
                        }}>
                            <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '8px',
                                marginBottom: '8px'
                            }}>
                                <i className="fa fa-history" aria-hidden="true" style={{ color: COLORS.primary_color_shade7, fontSize: '16px' }}></i>
                                <h3 style={{ 
                                    margin: 0, 
                                    color: COLORS.black8, 
                                    fontSize: '16px', 
                                    fontWeight: '600'
                                }}>
                                    Old Due ({STUDENT_NAME})
                                </h3>
                            </div>
                            <div style={{ 
                                display: 'flex',
                                gap: '8px',
                                flexWrap: 'wrap'
                            }}>
                                <div style={{
                                    background: oldDueTotals.totalOldDue > 0 ? COLORS.radish1 : COLORS.green_light,
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: `1px solid ${oldDueTotals.totalOldDue > 0 ? COLORS.card_red : COLORS.card_green}`,
                                    flex: '1',
                                    minWidth: '150px'
                                }}>
                                    <div style={{
                                        color: oldDueTotals.totalOldDue > 0 ? COLORS.card_red : COLORS.green_dark,
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        marginBottom: '4px'
                                    }}>
                                        Total Old Due
                                    </div>
                                    <div style={{
                                        color: oldDueTotals.totalOldDue > 0 ? COLORS.card_red : COLORS.green_dark,
                                        fontSize: '18px',
                                        fontWeight: '700'
                                    }}>
                                        Rs. {oldDueTotals.totalOldDue}
                                    </div>
                                </div>
                                <div style={{
                                    background: COLORS.grey2,
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: `1px solid ${COLORS.grey4}`,
                                    flex: '1',
                                    minWidth: '150px'
                                }}>
                                    <div style={{
                                        color: COLORS.black6,
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        marginBottom: '4px'
                                    }}>
                                        Accessories Due
                                    </div>
                                    <div style={{
                                        color: COLORS.black6,
                                        fontSize: '18px',
                                        fontWeight: '700'
                                    }}>
                                        {oldDueTotals.accessories_due === '' ? '—' : `Rs. ${oldDueTotals.accessories_due}`}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* All Session Due Section */}
                    <div style={{ 
                        marginBottom: '12px',
                        background: COLORS.white,
                        borderRadius: '14px',
                        border: '1px solid #e5e7eb',
                        boxShadow: '0 4px 12px rgba(15,23,42,0.08)',
                        overflow: 'hidden'
                    }}>
                        {/* Header */}
                        <div style={{ 
                            padding: '8px 12px',
                            background: `linear-gradient(135deg, ${COLORS.primary_color_shade7}, ${COLORS.primary_color_shade5})`,
                            borderBottom: '1px solid rgba(255,255,255,0.1)'
                        }}>
                            <h3 style={{ 
                                margin: 0, 
                                color: COLORS.white, 
                                fontSize: '18px', 
                                fontWeight: '600',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}>
                                <i className="fa fa-calendar-check-o" aria-hidden="true"></i>
                                All Session Due ({STUDENT_NAME})
                            </h3>
                        </div>

                        {/* Session Cards Grid */}
                        <div style={{ 
                            padding: '12px',
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', 
                            gap: '8px' 
                        }}>
                            {mAllSessionPayDetails &&
                                mAllSessionPayDetails.map((item, index) => {
                                    const hasDue = item.pay_details[0].total_due != 0;
                                    return (
                                        <div
                                            key={index}
                                            onClick={() => onSessionPayDetailClicked(item)}
                                            style={{
                                                background: hasDue 
                                                    ? `linear-gradient(135deg, ${COLORS.card_red}, ${COLORS.radish5})`
                                                    : `linear-gradient(135deg, ${COLORS.card_green}, ${COLORS.green3})`,
                                                borderRadius: '12px',
                                                padding: '10px',
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease',
                                                position: 'relative',
                                                overflow: 'hidden'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-4px)';
                                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                                            }}
                                        >
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'flex-start',
                                                marginBottom: '6px'
                                            }}>
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ 
                                                        color: COLORS.white, 
                                                        fontSize: '16px', 
                                                        fontWeight: '600',
                                                        marginBottom: '4px'
                                                    }}>
                                                        {item.session_name}
                                                        </div>
                                                    <div style={{ 
                                                        color: COLORS.white, 
                                                        fontSize: '20px', 
                                                        fontWeight: '700'
                                                    }}>
                                                        Rs. {item.pay_details[0].total_due}
                                                    </div>
                                                </div>
                                                <div
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        iclick(item);
                                                    }}
                                                    style={{
                                                        width: '28px',
                                                        height: '28px',
                                                        borderRadius: '50%',
                                                        background: 'rgba(255,255,255,0.25)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        cursor: 'pointer',
                                                        color: COLORS.white,
                                                        fontWeight: 'bold',
                                                        fontSize: '13px',
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.background = 'rgba(255,255,255,0.4)';
                                                        e.currentTarget.style.transform = 'scale(1.1)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.background = 'rgba(255,255,255,0.25)';
                                                        e.currentTarget.style.transform = 'scale(1)';
                                                    }}
                                                >
                                                                     i
                                                        </div>
                                                    </div>
                                                </div>
                                    );
                                })}
                        </div>
                    </div>

                    {/* Current Due Section */}
                    <div style={{ 
                        marginBottom: '12px',
                        background: COLORS.white,
                        borderRadius: '14px',
                        border: '1px solid #e5e7eb',
                        boxShadow: '0 4px 12px rgba(15,23,42,0.08)',
                        overflow: 'hidden'
                    }}>
                        {/* Header */}
                        <div style={{ 
                            padding: '8px 12px',
                            background: `linear-gradient(135deg, ${COLORS.primary_color_shade7}, ${COLORS.primary_color_shade5})`,
                            borderBottom: '1px solid rgba(255,255,255,0.1)'
                        }}>
                            <h3 style={{ 
                                margin: 0, 
                                color: COLORS.white, 
                                fontSize: '18px', 
                                fontWeight: '600',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}>
                                <i className="fa fa-file-text-o" aria-hidden="true"></i>
                                Current Due: {SESSION_NAME} ({STUDENT_NAME})
                            </h3>
                    </div>

                        {/* Fee Details */}
                        <div style={{ 
                            padding: '12px',
                            display: 'flex', 
                            flexDirection: 'column', 
                            gap: '8px' 
                        }}>
                                {mStudentDueFee &&
                                mStudentDueFee.map((item, index) => {
                                    const mFeeName = item.applicable_fee || [];
                                    const advanceMonth = isAdvanceMonth(item);
                                    const monthHeaderBg = advanceMonth
                                        ? `linear-gradient(135deg, ${COLORS.primary_color_shade3}, ${COLORS.primary_color_shade6})`
                                        : `linear-gradient(135deg, ${COLORS.primary_color_shade1}, ${COLORS.primary_color_shade2})`;
                                    const monthHeaderBgHover = advanceMonth
                                        ? `linear-gradient(135deg, ${COLORS.primary_color_shade4}, ${COLORS.primary_color_shade7})`
                                        : `linear-gradient(135deg, ${COLORS.primary_color_shade2}, ${COLORS.primary_color_shade3})`;
                                    const monthTitleColor = advanceMonth ? COLORS.white : COLORS.primary_color_shade8;
                                    const monthAccent = advanceMonth ? COLORS.primary_color_shade3 : COLORS.primary_color_shade5;
                                    const monthAccentDark = advanceMonth ? COLORS.primary_color_shade6 : COLORS.primary_color_shade6;
                                    const monthCheckboxUncheckedBorder = advanceMonth ? 'rgba(255,255,255,0.55)' : COLORS.grey4;
                                    const monthCheckboxUncheckedBg = advanceMonth ? 'rgba(255,255,255,0.12)' : COLORS.white;
                                    return (
                                        <div
                                            key={index}
                                            style={{
                                                background: COLORS.white,
                                                borderRadius: '14px',
                                                border: advanceMonth ? `1px solid ${COLORS.primary_color_shade3}` : '1px solid #e5e7eb',
                                                boxShadow: '0 4px 12px rgba(15,23,42,0.08)',
                                                overflow: 'hidden',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(15,23,42,0.12)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(15,23,42,0.08)';
                                            }}
                                        >
                                            {/* Month Header */}
                                            <div
                                                onClick={() => selectCollectionMonth(index)}
                                                style={{
                                                    background: monthHeaderBg,
                                                    padding: '8px 12px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.background = monthHeaderBgHover;
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.background = monthHeaderBg;
                                                }}
                                            >
                                                <div
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        selectCollectionMonth(index);
                                                    }}
                                                    style={{
                                                        width: '26px',
                                                        height: '26px',
                                                        minWidth: '26px',
                                                        borderRadius: '6px',
                                                        border: `2px solid ${item.isChecked === 'true' ? monthAccent : monthCheckboxUncheckedBorder}`,
                                                        background: item.isChecked === 'true' 
                                                            ? `linear-gradient(135deg, ${monthAccent}, ${monthAccentDark})`
                                                            : monthCheckboxUncheckedBg,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s ease',
                                                        boxShadow: item.isChecked === 'true' 
                                                            ? `0 2px 8px ${advanceMonth ? 'rgba(3,169,244,0.4)' : 'rgba(3,169,244,0.3)'}`
                                                            : '0 1px 3px rgba(0,0,0,0.1)',
                                                        position: 'relative'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (item.isChecked !== 'true') {
                                                            e.currentTarget.style.borderColor = monthAccent;
                                                            e.currentTarget.style.boxShadow = `0 2px 8px ${advanceMonth ? 'rgba(3,169,244,0.3)' : 'rgba(3,169,244,0.2)'}`;
                                                        } else {
                                                            e.currentTarget.style.transform = 'scale(1.05)';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (item.isChecked !== 'true') {
                                                            e.currentTarget.style.borderColor = advanceMonth ? 'rgba(255,255,255,0.7)' : COLORS.grey4;
                                                            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                                                        } else {
                                                            e.currentTarget.style.transform = 'scale(1)';
                                                        }
                                                    }}
                                                >
                                                    {item.isChecked === 'true' && (
                                                        <i 
                                                            className="fa fa-check" 
                                                            aria-hidden="true"
                                                            style={{
                                                                color: COLORS.white,
                                                                fontSize: '14px',
                                                                fontWeight: 'bold'
                                                            }}
                                                        ></i>
                                                    )}
                                                </div>
                                                <p style={{
                                                    margin: 0,
                                                    fontSize: '17px',
                                                    fontWeight: '600',
                                                    color: monthTitleColor,
                                                    flex: 1
                                                }}>
                                                    {item.month2}{advanceMonth ? <span style={{ fontStyle: 'italic', fontWeight: '500', opacity: 0.92 }}> (Advance)</span> : ''}
                                                </p>
                                            </div>

                                            {/* Fee Items */}
                                            {mFeeName && mFeeName.map((item2, index2) => {
                                                const isDue = item2.payment_status === 'Due';
                                                const isAdvanceFee = advanceMonth && item2.payment_status === 'Not Paid';
                                                return (
                                                    <div key={index2}>
                                                        <div
                                                            onClick={() => selectFeeName(index, index2)}
                                                            style={{
                                                                padding: '8px 12px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '8px',
                                                                borderBottom: '1px solid #f3f4f6',
                                                                cursor: 'pointer',
                                                                transition: 'all 0.2s ease',
                                                                background: item2.isChecked === 'true' ? COLORS.primary_color_shade0 : COLORS.white
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                if (item2.isChecked !== 'true') {
                                                                    e.currentTarget.style.background = COLORS.grey0;
                                                                }
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                if (item2.isChecked !== 'true') {
                                                                    e.currentTarget.style.background = COLORS.white;
                                                                }
                                                            }}
                                                        >
                                                            <div
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    selectFeeName(index, index2);
                                                                }}
                                                                style={{
                                                                    width: '24px',
                                                                    height: '24px',
                                                                    minWidth: '24px',
                                                                    borderRadius: '5px',
                                                                    border: `2px solid ${item2.isChecked === 'true' ? COLORS.primary_color_shade5 : COLORS.grey4}`,
                                                                    background: item2.isChecked === 'true' 
                                                                        ? `linear-gradient(135deg, ${COLORS.primary_color_shade5}, ${COLORS.primary_color_shade6})`
                                                                        : COLORS.white,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    cursor: 'pointer',
                                                                    transition: 'all 0.2s ease',
                                                                    boxShadow: item2.isChecked === 'true' 
                                                                        ? `0 2px 6px rgba(3,169,244,0.3)`
                                                                        : '0 1px 2px rgba(0,0,0,0.08)',
                                                                    position: 'relative'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    if (item2.isChecked !== 'true') {
                                                                        e.currentTarget.style.borderColor = COLORS.primary_color_shade5;
                                                                        e.currentTarget.style.boxShadow = `0 2px 6px rgba(3,169,244,0.2)`;
                                                                    } else {
                                                                        e.currentTarget.style.transform = 'scale(1.05)';
                                                                    }
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    if (item2.isChecked !== 'true') {
                                                                        e.currentTarget.style.borderColor = COLORS.grey4;
                                                                        e.currentTarget.style.boxShadow = '0 1px 2px rgba(0,0,0,0.08)';
                                                                    } else {
                                                                        e.currentTarget.style.transform = 'scale(1)';
                                                                    }
                                                                }}
                                                            >
                                                                {item2.isChecked === 'true' && (
                                                                    <i 
                                                                        className="fa fa-check" 
                                                                        aria-hidden="true"
                                                                        style={{
                                                                            color: COLORS.white,
                                                                            fontSize: '13px',
                                                                            fontWeight: 'bold'
                                                                        }}
                                                                    ></i>
                                                                )}
                                                        </div>
                                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                                <p style={{
                                                                    margin: 0,
                                                                    fontSize: '15px',
                                                                    fontWeight: '500',
                                                                    color: COLORS.black8
                                                                }}>
                                                                    {item2.fee_name}
                                                                </p>
                                                            </div>
                                                            {/* Move Up/Down Buttons - Only show when distributing */}
                                                            {otherAmount && parseFloat(otherAmount) > 0 && (
                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    gap: '2px',
                                                                    marginRight: '8px'
                                                                }}>
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        moveFeeUp(index, index2);
                                                                    }}
                                                                    disabled={index2 === 0}
                                                                    style={{
                                                                        width: '24px',
                                                                        height: '20px',
                                                                        padding: 0,
                                                                        border: 'none',
                                                                        background: index2 === 0 
                                                                            ? COLORS.grey2 
                                                                            : COLORS.primary_color_shade1,
                                                                        color: index2 === 0 
                                                                            ? COLORS.grey4 
                                                                            : COLORS.primary_color_shade7,
                                                                        borderRadius: '4px',
                                                                        cursor: index2 === 0 ? 'not-allowed' : 'pointer',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        fontSize: '10px',
                                                                        transition: 'all 0.2s ease',
                                                                        opacity: index2 === 0 ? 0.5 : 1
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        if (index2 !== 0) {
                                                                            e.currentTarget.style.background = COLORS.primary_color_shade3;
                                                                            e.currentTarget.style.transform = 'scale(1.1)';
                                                                        }
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        if (index2 !== 0) {
                                                                            e.currentTarget.style.background = COLORS.primary_color_shade1;
                                                                            e.currentTarget.style.transform = 'scale(1)';
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="fa fa-chevron-up"></i>
                                                                </button>
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        moveFeeDown(index, index2);
                                                                    }}
                                                                    disabled={index2 === mFeeName.length - 1}
                                                                    style={{
                                                                        width: '24px',
                                                                        height: '20px',
                                                                        padding: 0,
                                                                        border: 'none',
                                                                        background: index2 === mFeeName.length - 1 
                                                                            ? COLORS.grey2 
                                                                            : COLORS.primary_color_shade1,
                                                                        color: index2 === mFeeName.length - 1 
                                                                            ? COLORS.grey4 
                                                                            : COLORS.primary_color_shade7,
                                                                        borderRadius: '4px',
                                                                        cursor: index2 === mFeeName.length - 1 ? 'not-allowed' : 'pointer',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        fontSize: '10px',
                                                                        transition: 'all 0.2s ease',
                                                                        opacity: index2 === mFeeName.length - 1 ? 0.5 : 1
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        if (index2 !== mFeeName.length - 1) {
                                                                            e.currentTarget.style.background = COLORS.primary_color_shade3;
                                                                            e.currentTarget.style.transform = 'scale(1.1)';
                                                                        }
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        if (index2 !== mFeeName.length - 1) {
                                                                            e.currentTarget.style.background = COLORS.primary_color_shade1;
                                                                            e.currentTarget.style.transform = 'scale(1)';
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="fa fa-chevron-down"></i>
                                                                </button>
                                                            </div>
                                                            )}
                                                            <div style={{
                                                                padding: '3px 8px',
                                                                borderRadius: '6px',
                                                                background: isDue
                                                                    ? COLORS.radish1
                                                                    : isAdvanceFee
                                                                        ? COLORS.primary_color_shade3
                                                                        : COLORS.green_light,
                                                                color: isDue
                                                                    ? COLORS.card_red
                                                                    : isAdvanceFee
                                                                        ? COLORS.white
                                                                        : COLORS.green_dark,
                                                                fontSize: '13px',
                                                                fontWeight: '600',
                                                                whiteSpace: 'nowrap',
                                                                marginRight: '8px',
                                                                minWidth: '75px',
                                                                textAlign: 'center',
                                                                display: 'inline-block'
                                                            }}>
                                                                {item2.payment_status}
                                                            </div>
                                                            {(() => {
                                                                const hasPartialPayment = item2.isChecked === 'true' && item2.payable_amount !== undefined && item2.payable_amount !== item2.outstanding;
                                                                const remainingDue = hasPartialPayment ? (item2.outstanding - item2.payable_amount) : 0;
                                                                const showRemaining = hasPartialPayment && remainingDue > 0;
                                                                const isFullyPaid = hasPartialPayment && remainingDue === 0;
                                                                
                                                                return (
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        alignItems: 'flex-end',
                                                                        gap: '2px'
                                                                    }}>
                                                                        <div style={{
                                                                            padding: '4px 10px',
                                                                            borderRadius: '6px',
                                                                            background: showRemaining 
                                                                                ? COLORS.radish1 
                                                                                : isFullyPaid 
                                                                                    ? COLORS.green_light 
                                                                                    : COLORS.primary_color_shade1,
                                                                            color: showRemaining 
                                                                                ? COLORS.card_red 
                                                                                : isFullyPaid 
                                                                                    ? COLORS.green_dark 
                                                                                    : COLORS.primary_color_shade7,
                                                                            fontSize: '14px',
                                                                            fontWeight: '600',
                                                                            whiteSpace: 'nowrap',
                                                                            textAlign: 'right',
                                                                            display: 'inline-block',
                                                                            width: '120px',
                                                                            boxSizing: 'border-box'
                                                                        }}>
                                                                            Rs. {hasPartialPayment 
                                                                                ? `${item2.payable_amount} / ${item2.outstanding}` 
                                                                                : item2.outstanding}
                                                            </div>
                                                                        {showRemaining && (
                                                                            <div style={{
                                                                                padding: '2px 8px',
                                                                                borderRadius: '4px',
                                                                                background: COLORS.radish1,
                                                                                color: COLORS.card_red,
                                                                                fontSize: '11px',
                                                                                fontWeight: '600',
                                                                                whiteSpace: 'nowrap',
                                                                                width: '120px',
                                                                                textAlign: 'right',
                                                                                boxSizing: 'border-box'
                                                                            }}>
                                                                                Remaining: Rs. {remainingDue}
                                                        </div>
                                                                        )}
                                                    </div>
                                                                );
                                                            })()}
                                            </div>

                                        </div>
                                );
                            })}

                                            {/* Subtotal */}
                                            <div style={{
                                                padding: '8px 12px',
                                                background: advanceMonth
                                                    ? `linear-gradient(135deg, ${COLORS.primary_color_shade3}, ${COLORS.primary_color_shade6})`
                                                    : `linear-gradient(135deg, ${COLORS.primary_color_shade1}, ${COLORS.primary_color_shade2})`,
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                alignItems: 'center'
                                            }}>
                                                <p style={{
                                                    margin: 0,
                                                    fontSize: '17px',
                                                    fontWeight: '700',
                                                    color: monthTitleColor
                                                }}>
                                                    Subtotal: <span style={{ color: advanceMonth ? COLORS.primary_color_shade0 : COLORS.primary_color_shade7 }}>Rs. {getSubtotal(index)}</span>
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>

                    {/* Collect By Other Amount Section */}
                    <div style={{
                        marginTop: '16px',
                        marginBottom: '16px',
                        padding: '16px',
                        background: COLORS.white,
                        borderRadius: '12px',
                        border: `1px solid ${COLORS.grey3 || '#E0E0E0'}`,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                    }}>
                        <div style={{
                            marginBottom: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            gap: '8px'
                        }}>
                            <h4 style={{
                                margin: 0,
                                fontSize: '16px',
                                fontWeight: '600',
                                color: COLORS.black8 || '#333333',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                            }}>
                                <i className="fa fa-calculator" style={{ color: COLORS.primary_color_shade6 }} />
                                Collect By Other Amount
                            </h4>
                            <label style={{
                                margin: 0,
                                fontSize: '14px',
                                fontWeight: '600',
                                color: COLORS.black8 || '#333333',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                            }}>
                                <i className="fa fa-rupee-sign" style={{ color: COLORS.primary_color_shade6 }} />
                                Enter Amount (Max: ₹{totalDueAmount.toLocaleString()})
                            </label>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <div>
                                <input
                                    type="number"
                                    value={otherAmount}
                                    onChange={(e) => handleOtherAmountChange(e.target.value)}
                                    placeholder="Enter amount to collect"
                                    min="0"
                                    max={totalDueAmount}
                                    style={{
                                        width: '100%',
                                        padding: '14px 16px',
                                        fontSize: '16px',
                                        border: `2px solid ${COLORS.grey3 || '#E0E0E0'}`,
                                        borderRadius: '10px',
                                        transition: 'all 0.3s ease',
                                        outline: 'none',
                                        boxSizing: 'border-box',
                                    }}
                                    onFocus={(e) => {
                                        e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || '#039BE5';
                                        e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
                                    }}
                                    onBlur={(e) => {
                                        e.currentTarget.style.borderColor = COLORS.grey3 || '#E0E0E0';
                                        e.currentTarget.style.boxShadow = 'none';
                                    }}
                                />
                                {otherAmount && parseFloat(otherAmount) > totalDueAmount && (
                                    <div style={{
                                        marginTop: '8px',
                                        padding: '8px 12px',
                                        background: COLORS.red1 || '#FFEBEE',
                                        border: `1px solid ${COLORS.red3 || '#EF5350'}`,
                                        borderRadius: '6px',
                                        color: COLORS.red7 || '#d32f2f',
                                        fontSize: '13px',
                                    }}>
                                        <i className="fa fa-exclamation-circle" style={{ marginRight: '6px' }} />
                                        Amount cannot exceed total due of ₹{totalDueAmount.toLocaleString()}
                    </div>
                                )}
                            </div>
                            {otherAmount && parseFloat(otherAmount) > 0 && parseFloat(otherAmount) <= totalDueAmount && (
                                <div style={{
                                    padding: '12px',
                                    background: COLORS.green1 || '#C8E6C9',
                                    border: `1px solid ${COLORS.green3 || '#38B503'}`,
                                    borderRadius: '8px',
                                    fontSize: '13px',
                                    color: COLORS.green4 || '#2C8D02',
                                }}>
                                    <i className="fa fa-info-circle" style={{ marginRight: '6px' }} />
                                    <strong>₹{parseFloat(otherAmount).toLocaleString()}</strong> will be automatically distributed across dues. Check the dues above to see the distribution.
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        gap: '8px',
                        marginTop: '12px',
                        marginBottom: '12px'
                    }}>
                        {/* Distribution Validation Message */}
                        {!isDistributionPossible && getDistributionValidationMessage && (
                            <div style={{
                                padding: '10px 14px',
                                borderRadius: '8px',
                                background: COLORS.radish1,
                                border: `1px solid ${COLORS.card_red}`,
                                color: COLORS.card_red,
                                fontSize: '13px',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                marginBottom: '4px'
                            }}>
                                <i className="fa fa-exclamation-triangle" style={{ fontSize: '14px' }}></i>
                                <span>{getDistributionValidationMessage}</span>
                    </div>
                        )}
                        <button
                            onClick={HandleShowModalFeeConfirmation}
                            disabled={!isDistributionPossible}
                            style={{
                                padding: '12px 16px',
                                width: '100%',
                                fontSize: '17px',
                                fontWeight: '700',
                                borderRadius: '12px',
                                background: isDistributionPossible 
                                    ? `linear-gradient(135deg, ${COLORS.primary_color_shade6}, ${COLORS.primary_color_shade7})`
                                    : COLORS.grey3,
                                border: 'none',
                                boxShadow: isDistributionPossible 
                                    ? '0 6px 20px rgba(2,136,209,0.3)'
                                    : 'none',
                                transition: 'all 0.3s ease',
                                color: COLORS.white,
                                cursor: isDistributionPossible ? 'pointer' : 'not-allowed',
                                opacity: isDistributionPossible ? 1 : 0.6
                            }}
                            onMouseEnter={(e) => {
                                if (isDistributionPossible) {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(2,136,209,0.4)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (isDistributionPossible) {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(2,136,209,0.3)';
                                }
                            }}
                        >
                            <i className="fa fa-money" aria-hidden="true" style={{ marginRight: '10px' }}></i>
                            Collect Now (Rs. {netPayableAmount})
                        </button>
                    </div>

                    {showFeeConfirmation === true ? <ModalFeeConfirmation action={HandleCloseModalFeeConfirmation} action2={submitFeeDetails} netPayableAmount={netPayableAmount}></ModalFeeConfirmation> : ''}
                    {isOpeniclick === true ? <MdlFeePayDetails actionClose={HandleCloseiclick} pay_details={mSessionPayDetails}></MdlFeePayDetails> : ''}
                </div>
            )
        }
    }
}

export default DueFeeCollection;
